import { PageStateData } from "org/pageState/models";
import { Codecs } from "org/pageState/types";

type DashboardPageStateWithType = PageStateData<"Dashboard"> & {
    type: "Dashboard";
};

// No special encoding needed for the dashboard.
// The format of data persisted is the same as the one used in the frontend.
const pageStateDashboardCodecs: Codecs<
    PageStateData<"Dashboard">,
    DashboardPageStateWithType
> = {
    encode: (state: PageStateData<"Dashboard">): DashboardPageStateWithType => {
        return { ...state, type: "Dashboard" };
    },
    decode: (state: DashboardPageStateWithType): PageStateData<"Dashboard"> =>
        state,
};

export { pageStateDashboardCodecs };
